export const ACCOUNT_GROUP_ID = 'accountGroupId';
export const SOURCE_ID = 'sourceId';
export const CUSTOMER_ID = 'customerId';
export const TEMPLATE_ID = 'templateId';

const baseRoute = `cv/account/:${ACCOUNT_GROUP_ID}`;

export const EntryRoute = `cv/entry/:${ACCOUNT_GROUP_ID}`;

export class ApplicationRoutes {
  static readonly customerLandingPage: string = `cv/reviews/customer-form`;
  static readonly overview: string = `${baseRoute}/overview`;
  static readonly customers: string = `${baseRoute}/customers`;
  static readonly customerEvents: string = `${baseRoute}/customers/:${CUSTOMER_ID}/events`;
  static readonly sendEmail: string = `${baseRoute}/customers/send-email`;
  static readonly sendReviewRequest: string = `${baseRoute}/customers/send-review-request`;
  static readonly oldWidgetRoute: string = `${baseRoute}/widget`;
  static readonly tools: string = `${baseRoute}/tools`;
  static readonly widgets: string = `${baseRoute}/tools/widgets`;
  static readonly kiosk: string = `${baseRoute}/tools/kiosk`;
  static readonly settings: string = `${baseRoute}/settings`;
  static readonly preferredSites: string = `${baseRoute}/settings/preferred-sites`;
  static readonly confirmationMessages: string = `${baseRoute}/settings/confirmation-messages`;
  static readonly reviewPageUrls: string = `${baseRoute}/settings/review-page-urls`;
  static readonly smsConfiguration: string = `${baseRoute}/settings/sms-configuration`;
  static readonly templates: string = `${baseRoute}/templates`;
  static readonly editEmailTemplate: string = `${baseRoute}/templates/email/:${TEMPLATE_ID}`;
  static readonly editSmsTemplate: string = `${baseRoute}/templates/sms/:${TEMPLATE_ID}`;
}

export class ToolsRoutes {
  static readonly widget: string = `widgets`;
  static readonly kiosk: string = `kiosk`;
}

export class SettingsRoutes {
  static readonly preferredSites: string = `preferred-sites`;
  static readonly email: string = `email`;
  static readonly sms: string = `sms`;
  static readonly confirmationMessages: string = `confirmation-messages`;
  static readonly reviewPageUrls: string = `review-page-urls`;
  static readonly smsConfiguration: string = `sms-configuration`;
  static readonly manageTemplates: string = `manage-templates`;
  static readonly editTemplate: string = `manage-templates/:templateId`;
}

const apiV1 = `ajax/v1`;
const apiV2 = `ajax/v2`;

export class ApiRoutesV1 {
  static readonly productNavbar: string = `${baseRoute}/${apiV1}/product-navbar-data/`;
  static readonly appConfig: string = `${baseRoute}/${apiV1}/app-config/`;
  static readonly imageUploadUrl: string = `${baseRoute}/${apiV1}/settings/email/image-upload`;

  static readonly reviewSmsUsage: string = `${baseRoute}/${apiV1}/review/smsUsage/`;

  static readonly customerAddSingle: string = `${baseRoute}/${apiV1}/customers/add/`;
  static readonly customerGetEvents: string = `${baseRoute}/${apiV1}/review/events/list/`;

  static readonly sendEmailRequests: string = `${baseRoute}/${apiV1}/review/sendRequests/`;
  static readonly sendSmsRequestsBulk: string = `${baseRoute}/${apiV1}/review/sendRequestSMSMessagesBulk/`;

  static readonly reviewGenerationSettingsGet: string = `${baseRoute}/${apiV1}/reviewGenerationSettings/get/`;
  static readonly confirmationMessageGetDefault: string = `${baseRoute}/${apiV1}/review-generation-settings/get-default-confirmation-messages`;
  static readonly confirmationMessageUpdate: string = `${baseRoute}/${apiV1}/review-generation-settings/update-confirmation-messages`;
  static readonly sendToGoogleUpdate: string = `${baseRoute}/${apiV1}/review-generation-settings/update-send-to-google`;
  static readonly defaultTemplateIdGet: string = `${baseRoute}/${apiV1}/review-generation-settings/default-email-template-id/get`;
  static readonly defaultTemplateIdUpdate: string = `${baseRoute}/${apiV1}/review-generation-settings/default-email-template-id/update`;

  static readonly settingsEmailWorkflow: string = `${baseRoute}/${apiV1}/settings/email/workflow`;
  static readonly settingsEmailGet: string = `${baseRoute}/${apiV1}/settings/email/get`;
  static readonly settingsEmailUpdate: string = `${baseRoute}/${apiV1}/settings/email/update`;
  static readonly settingsEmailGetDefaults: string = `${baseRoute}/${apiV1}/settings/email/get-defaults`;
  static readonly settingsEmailGetGreetings: string = `${baseRoute}/${apiV1}/settings/email/get-greetings`;
  static readonly settingsEmailImage: string = `${baseRoute}/${apiV1}/settings/email/images`;

  static readonly sourcesSettingsGet: string = `${baseRoute}/${apiV1}/reviews/sources/settings/get/`;
  static readonly sourcesSettingsUpdate: string = `${baseRoute}/${apiV1}/reviews/sources/settings/update/`;

  static readonly reviewUrlMyListing: string = `${baseRoute}/${apiV1}/settings/review-urls/my-listing`;

  static readonly smsGetBodyCharacterLimit: string = `${baseRoute}/${apiV1}/SMStemplates/get-body-character-limit`;
  static readonly smsGetPreview: string = `${baseRoute}/${apiV1}/SMStemplates/get-sms-message-preview`;

  static readonly templateCreate: string = `${baseRoute}/${apiV1}/template/create/`;
  static readonly templateUpdate: string = `${baseRoute}/${apiV1}/template/update/`;
  static readonly templateRender: string = `${baseRoute}/${apiV1}/template/render/`;
  static readonly templateEmailPreview: string = `${baseRoute}/${apiV1}/template/email/preview/`;

  static readonly getReviewStats: string = `${baseRoute}/${apiV1}/reviews/count/`;
}

export class ApiRoutesV2 {
  static readonly customerLookup: string = `${baseRoute}/${apiV2}/customers/lookup`;
  static readonly customerAdd: string = `${baseRoute}/${apiV2}/customers/add-bulk/`;
  static readonly customerDelete: string = `${baseRoute}/${apiV2}/customers/delete/`;
  static readonly customerExists: string = `${baseRoute}/${apiV2}/customer/exist/`;
  static readonly templateList: string = `${baseRoute}/${apiV2}/template/list/`;
  static readonly templateRender: string = `${baseRoute}/${apiV2}/template/render/`;
  static readonly templateDelete: string = `${baseRoute}/${apiV2}/template/delete/`;
  static readonly templateUpdateSms: string = `${baseRoute}/${apiV2}/template/update-sms/`;
  static readonly templateGet: string = `${baseRoute}/${apiV2}/template/get/`;
  static readonly reviewEmailUsage: string = `${baseRoute}/${apiV2}/email/monthly-usage/`;
  static readonly tagList: string = `${baseRoute}/${apiV2}/customers/list-tags/`;
  static readonly vbcHostGet: string = `${baseRoute}/${apiV2}/vbc-host/get/`;
}

export class GenericRoutes {
  static readonly reviewShareUrl: string = `cv/review/share/:${ACCOUNT_GROUP_ID}/:${SOURCE_ID}/`;
}

export function getRouteUrlByAccountGroupId(route: string, accountGroupId: string): string {
  return route.replace(`:${ACCOUNT_GROUP_ID}`, accountGroupId);
}
